import * as React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

const data = [
  { admin: "John", handleTime: 120 },
  { admin: "Jane", handleTime: 90 },
  { admin: "Bob", handleTime: 150 },
  { admin: "Mary", handleTime: 110 },
  // Add more data as needed
];

const columns = [
  { id: "admin", label: "Admin" },
  { id: "handleTime", label: "Average Handle Time" },
];

const averageHandleTime = (data) => {
  const totalHandleTime = data.reduce((acc, curr) => acc + curr.handleTime, 0);
  const averageHandleTime = totalHandleTime / data.length;
  return averageHandleTime;
};

const AdminStats = () => {
  const avgHandleTime = averageHandleTime(data);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id}>{column.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.admin}>
              {columns.map((column) => (
                <TableCell key={column.id}>{row[column.id]}</TableCell>
              ))}
            </TableRow>
          ))}
          <TableRow>
            <TableCell><strong>Average Handle Time</strong></TableCell>
            <TableCell><strong>{avgHandleTime}</strong></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AdminStats;
